import SpritesheetAsset from "../Components/SpritesheetAsset";

function CardAsset(props: { card: {text: string, suite: string }} ) {
    return (
        <div className="card">
            <SpritesheetAsset name={`${props.card.text}-${props.card.suite}.png`} />
        </div>
    );
}

export default CardAsset;
